import { useQuery } from '@apollo/client';

import {
  AvailabilityState,
  GetOutOfStockAlternativesQuery,
  GetOutOfStockAlternativesQueryVariables,
} from '@notino/shared/definitions/types';

import { useProductDetailContext } from '../ProductDetailContext';

import productAlternativesQuery from './queries/productAlternatives.graphql';

export const useFetchProductAlternatives = () => {
  const { product } = useProductDetailContext();
  const catTypes = product.categorization.types;

  const everyProductUnavailable = product.variants.every(
    (v) => v.availability.state !== AvailabilityState.CanBeBought
  );

  const typeId = catTypes?.find((t) => t.primary)?.id ?? catTypes?.[0]?.id;

  return useQuery<
    GetOutOfStockAlternativesQuery,
    GetOutOfStockAlternativesQueryVariables
  >(productAlternativesQuery, {
    variables: {
      productCode: product.masterProductCode,
      brandId: product.brand?.id ? Number(product.brand.id) : null,
      navigationValues: [typeId!],
    },
    skip: !everyProductUnavailable || typeId == null,
    ssr: false,
  });
};
